import { createContext } from "react";

type ChatApp = {
    name: string;
    key: string;
    knack_id?: string;
};

export type ConnectState = 'idle' | 'connecting' | 'failed';

type UserContextType = {
    app: ChatApp | null;
    setApp: (app: ChatApp | null) => void;
    user: string | null;
    setUser: (user: string | null) => void;
    userToken: string | null;
    setUserToken: (userToken: string | null) => void;
    moderatorMode: boolean;
    setModeratorMode: (moderatorMode: boolean) => void;
    streamTeam: string | null;
    userRole: string | null;
    setUserRole: (userRole: string) => void,
    userIsModerator: boolean | null;
    signIn: (session: { user: string; userToken: string; app: ChatApp }) => number;
    connectState: ConnectState;
    failedAttempt: number | null;
};


const UserContext = createContext<UserContextType>({
    app: null,
    setApp: () => { },
    user: null,
    setUser: () => { },
    userToken: null,
    setUserToken: () => { },
    moderatorMode: false,
    setModeratorMode: () => { },
    streamTeam: null,
    userRole: null,
    setUserRole: () => { },
    userIsModerator: false,
    signIn: () => 0,
    connectState: 'idle',
    failedAttempt: null,
});

export default UserContext;